"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.buildDepGraph = buildDepGraph;
const manifest = require("./manifest-parser");
const lockFile = require("./lock-file-parser");
const poetryDepGraphBuilder = require("./poetry-dep-graph-builder");
function buildDepGraph(manifestFileContents, lockFileContents, includeDevDependencies = false, includeComponentMetadata = false) {
    const dependencies = manifest.getDependenciesFrom(manifestFileContents, includeDevDependencies);
    const pkgDetails = manifest.pkgInfoFrom(manifestFileContents);
    const pkgSpecs = lockFile.packageSpecsFrom(lockFileContents);
    return poetryDepGraphBuilder.build(pkgDetails, dependencies, pkgSpecs, includeComponentMetadata);
}
//# sourceMappingURL=index.js.map